<template>
  <el-dialog class="rl-dialog">
    <!-- Fallthrough slots -->
    <slot />
    <template #header>
      <slot name="header" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<style lang="scss">
// Customize dialog
.rl-dialog {
  border: none !important;
  padding: 0;

  .el-dialog {
    &__title {
      font-weight: 400;
      color: var(--text-secondary);
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid var(--component-stroke-primary);
      padding: 16px 24px;

      button {
        background-color: var(--component-fill-primary);
        border-radius: 50%;
        position: inherit;
        height: 32px;
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: 20px;
          width: 20px;
        }
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    &__footer {
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: right;

      .el-button {
        background-color: var(--component-fill-primary);
        width: 128px;
        height: 44px;

        &.is-disabled {
          background-color: #68aff1; // Change to var
        }

        &--primary {
          background-color: var(--text-brand);
        }
      }
    }
  }
}
</style>
